export const FETCH_NAV_MENU_ITEMS = 'FETCH_NAV_MENU_ITEMS';
export const UPDATE_ACTIVE_NAV_MENU_ITEM_ID = 'UPDATE_ACTIVE_NAV_MENU_ITEM_ID';
export const FETCH_STORAGE_SPACE = 'FETCH_STORAGE_SPACE';
export const SETUP_ARCHIVE_PASSWORD = 'SETUP_ARCHIVE_PASSWORD';
export const RESET_ARCHIVE_PASSWORD_STATUS = 'RESET_ARCHIVE_PASSWORD_STATUS';
export const FETCH_CONTENT_ITEMS = 'FETCH_CONTENT_ITEMS';
export const SEARCH_CONTENT_ITEMS = 'SEARCH_CONTENT_ITEMS';
export const UPDATE_ACTIVE_CONTENT_TYPE = 'UPDATE_ACTIVE_CONTENT_TYPE';
export const FETCH_SHARED_CONTENT_ITEMS = 'FETCH_SHARED_CONTENT_ITEMS';
export const FETCH_FILE_VERSIONS = 'FETCH_FILE_VERSIONS';
export const CREATE_SHARED_LINK = 'CREATE_SHARED_LINK';
export const DELETE_SHARED_LINK = 'DELETE_SHARED_LINK';
export const FETCH_SHARED_LINK_SETTINGS = 'FETCH_SHARED_LINK_SETTINGS';
export const UPDATE_SHARED_LINK_SETTINGS = 'UPDATE_SHARED_LINK_SETTINGS';
export const UPDATE_ACTIVE_VERSION_PATH = 'UPDATE_ACTIVE_VERSION_PATH';
export const UPDATE_ACTIVE_VOLUME_PATH = 'UPDATE_ACTIVE_VOLUME_PATH';
export const SORT_CONTENT_ITEMS = 'SORT_CONTENT_ITEMS';
export const SORT_SHARED_CONTENT_ITEMS = 'SORT_SHARED_CONTENT_ITEMS';
export const FETCH_SUB_ACCOUNT_ITEMS = 'FETCH_SUB_ACCOUNT_ITEMS';
export const UPDATE_ACTIVE_SUB_ACCOUNT = 'UPDATE_ACTIVE_SUB_ACCOUNT';
export const CHECK_SUB_ACCOUNT_EXISTS = 'CHECK_SUB_ACCOUNT_EXISTS';
export const FETCH_SUB_ACCOUNT_ARCHIVES = 'FETCH_SUB_ACCOUNT_ARCHIVES';
export const UPDATE_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID = 'UPDATE_ACTIVE_VOLUME_SB_SUB_ACCOUNT_ID';
